import type { QuestionnaireRevisionContext } from '@gcv/shared';
import { QuestionnaireStatus } from '@gcv/shared';

export const getLatestCompletedRevision = (
  history: QuestionnaireRevisionContext[] | undefined
): QuestionnaireRevisionContext | undefined => {
  if (!history?.length) return undefined;
  const completed = history.filter((entry) => entry.status === QuestionnaireStatus.Completed);
  if (!completed.length) return undefined;
  return completed.reduce(
    (acc, entry) => (entry.revision_number > acc.revision_number ? entry : acc),
    completed[0]
  );
};
